import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Input, Row, Col, Checkbox, DatePicker } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'antd/lib/modal/Modal';
import moment from 'moment';
import { useHistory } from 'react-router';
import { EditOutlined } from '@ant-design/icons';

import GetField from '../Components/GetField';
import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import {
  getTimeAction,
  clearTimeAction,
  getUsers,
  clearUsers,
} from '../Actions';
import Breadcrumbs from '../Components/Breadcrumbs';
import { get } from '../utils';
import constants from '../constants';
import timeactions from '../timeactions';

const AntInput = GetField(Input);
const AntDatePicker = GetField(DatePicker);
const AntCheckbox = GetField(Checkbox);
const AntInputTextArea = GetField(Input.TextArea);

const ViewTimeAction = props => {
  const { classes, match } = props;
  const history = useHistory();

  const dispatch = useDispatch();

  const timeAction = useSelector(state => state.timeAction);
  const auth = useSelector(state => state.auth);
  const permissions = useMemo(() => get(auth, ['permissions'], []), [auth]);

  const [Activity, SetActivity] = useState(null);
  const [SubActivities, SetSubActivities] = useState(null);
  const [IsLoading, SetIsLoading] = useState(false);

  const { handleSubmit, control, getValues, setValue } = useForm({
    shouldUnregister: false,
  });

  useEffect(() => {
    dispatch(getTimeAction(match.params.id));
    dispatch(getUsers());
    return () => {
      dispatch(clearTimeAction());
      dispatch(clearUsers());
    };
  }, []);

  const onSubmit = async () => {
    try {
      SetIsLoading(true);
      const remark = getValues('remark');
      await Api.post('/timeactions/complete', {
        remark,
        activityId: Activity.activityId,
        subActivityId: Activity.subActivityId,
      });
      successNotification('Time & Action Plan added.');
      setValue('remark', null);
      SetIsLoading(false);
      SetActivity(null);
      dispatch(getTimeAction(match.params.id));
    } catch (err) {
      errorNotification(err);
      SetIsLoading(false);
    }
  };

  return (
    <>
      <Breadcrumbs
        moduleName="Jobcharts"
        moduleLink="/jobcharts/list"
        subModuleName="Time & Action View"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <AntInput
              label="Customer"
              placeholder="Customer"
              value={timeAction.customer}
              disabled
            />
          </LeftGrid>
          <RightGrid>
            <AntInput
              label="BPO #"
              placeholder="BPO #"
              value={timeAction.bpoNo}
              disabled
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <AntDatePicker
              allowClear
              label="Int. PPMD"
              placeholder="Int. PPMD"
              // value={timeAction.intPPMD ? moment(timeAction.intPPMD) : null}
              disabled
            />
          </LeftGrid>
          <RightGrid>
            <AntDatePicker
              allowClear
              label="Ext. PPMD"
              placeholder="Ext. PPMD"
              disabled
              // value={timeAction.extPPMD ? moment(timeAction.intPPMD) : null}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <AntCheckbox
              allowClear
              label="Is Reorder?"
              value={timeAction.isReorder}
              disabled
            />
          </LeftGrid>
          <RightGrid>
            <AntInputTextArea
              allowClear
              label="Remark"
              placeholder="Remark"
              value={timeAction.remark}
              rows={1}
              disabled
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <strong>Products: </strong>
            {timeAction.products}
          </LeftGrid>
          {permissions.includes(constants.permissions.timeAction) ? (
            <RightGrid>
              <Button
                className={classes.marginBetweenSelect}
                onClick={() =>
                  history.push(`/timeactions/update/${match.params.id}`)
                }
                icon={<EditOutlined />}
              >
                Update
              </Button>
            </RightGrid>
          ) : null}
        </Row>
        <br />
        <Row>
          <Col
            xs={{ span: 22, offset: 1 }}
            md={{ span: 22, offset: 1 }}
            lg={{ span: 22, offset: 1 }}
            xl={{ span: 20, offset: 2 }}
          >
            <table className={classes.inputTable}>
              <thead className={classes.inputThead}>
                <tr>
                  <th className={classes.inputTh}>Task</th>
                  <th className={classes.inputTh}>Assignee</th>
                  <th className={classes.inputTh}>Plan Date</th>
                  <th className={classes.inputTh}>Mod Plan Date</th>
                  <th className={classes.inputTh}>Modification Reason</th>
                  <th className={classes.inputTh}>Completed On</th>
                  <th className={classes.inputTh}>Remark</th>
                  <th className={classes.inputTh}>Status</th>
                  <th className={classes.inputTh}>Action</th>
                </tr>
              </thead>
              <tbody>
                {timeAction.activities.map(item => (
                  <tr key={item.id}>
                    <td className={classes.inputTd}>{item.task}</td>
                    <td className={classes.inputTd}>{item.assignee}</td>
                    <td className={classes.inputTd}>
                      {moment(item.plannedAt).format('DD MMM YYYY')}
                    </td>
                    <td className={classes.inputTd}>
                      {item.modPlannedAt
                        ? moment(item.modPlannedAt).format('DD MMM YYYY')
                        : 'Not Modified'}
                    </td>
                    <td className={classes.inputTd}>
                      {item.modificationRemark}
                    </td>
                    <td className={classes.inputTd}>
                      {item.completedAt
                        ? moment(item.completedAt).format('DD MMM YYYY')
                        : null}
                    </td>
                    <td className={classes.inputTd}>{item.remark}</td>
                    <td className={classes.inputTd}>
                      {item.completedAt &&
                      new Date(item.completedAt) >
                        new Date(item.modPlannedAt || item.plannedAt)
                        ? `${moment(item.completedAt)
                            .endOf('day')
                            .diff(
                              item.modPlannedAt || item.plannedAt,
                              'day'
                            )} days delayed`
                        : null}
                    </td>
                    <td className={classes.inputTd}>
                      {item.subActivities && item.subActivities.length ? (
                        <div style={{ textAlign: 'center', width: '100%' }}>
                          <Button
                            style={{
                              backgroundColor: '#cfcfcf',
                              color: '#0b2933',
                            }}
                            onClick={() => SetSubActivities(item.subActivities)}
                            type="primary"
                          >
                            Sub Tasks
                          </Button>
                        </div>
                      ) : null}
                      {item.completedAt === null &&
                      item.assigneeId === auth?.user?.id &&
                      (!item.subActivities || !item.subActivities.length) ? (
                        <div style={{ textAlign: 'center', width: '100%' }}>
                          <Button
                            className={classes.button}
                            onClick={() =>
                              SetActivity({
                                activityId: item.id,
                                task: item.task,
                              })
                            }
                            type="primary"
                          >
                            Complete
                          </Button>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
        <br />
        {SubActivities && SubActivities.length ? (
          <Modal
            visible
            centered
            maskClosable={false}
            closable={false}
            onOk={() => SetSubActivities(null)}
            width="90%"
            okText="Close"
            cancelButtonProps={{ style: { display: 'none' } }}
            title={SubActivities[0].task}
          >
            <Row>
              <Col xs={24}>
                <table className={classes.inputTable}>
                  <thead className={classes.inputThead}>
                    <tr>
                      {SubActivities[0].fabric ? (
                        <>
                          <th className={classes.inputTh}>Fabric</th>
                          <th className={classes.inputTh}>Width</th>
                        </>
                      ) : null}
                      {[
                        timeactions.bulkLotSendApprovalDate,
                        timeactions.dyedFabricInhouseDate,
                        timeactions.printedFabricInhouseDate,
                        timeactions.acidWashFabricInhouseDate,
                      ].includes(SubActivities[0].task) ? (
                        <>
                          <th className={classes.inputTh}>Base Color</th>
                          <th className={classes.inputTh}>Print Color</th>
                        </>
                      ) : null}
                      {SubActivities[0].accessory ? (
                        <>
                          <th className={classes.inputTh}>Accessory</th>
                        </>
                      ) : null}
                      <th className={classes.inputTh}>Assignee</th>
                      <th className={classes.inputTh}>Plan Date</th>
                      <th className={classes.inputTh}>Mod Plan Date</th>
                      <th className={classes.inputTh}>Modification Reason</th>
                      <th className={classes.inputTh}>Completed On</th>
                      <th className={classes.inputTh}>Remark</th>
                      <th className={classes.inputTh}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SubActivities.map(item => (
                      <tr key={item.id}>
                        {item.fabric ? (
                          <>
                            <td className={classes.inputTd}>{item.fabric}</td>
                            <td className={classes.inputTd}>{item.width}</td>
                          </>
                        ) : null}
                        {[
                          timeactions.bulkLotSendApprovalDate,
                          timeactions.dyedFabricInhouseDate,
                          timeactions.printedFabricInhouseDate,
                          timeactions.acidWashFabricInhouseDate,
                        ].includes(SubActivities[0].task) ? (
                          <>
                            <td className={classes.inputTd}>
                              {item.baseColor}
                            </td>
                            <td className={classes.inputTd}>
                              {item.printColor}
                            </td>
                          </>
                        ) : null}
                        {item.accessory ? (
                          <>
                            <td className={classes.inputTd}>
                              {item.accessory}
                            </td>
                          </>
                        ) : null}
                        <td className={classes.inputTd}>{item.assignee}</td>
                        <td className={classes.inputTd}>
                          {moment(item.plannedAt).format('DD MMM YYYY')}
                        </td>
                        <td className={classes.inputTd}>
                          {item.modPlannedAt
                            ? moment(item.modPlannedAt).format('DD MMM YYYY')
                            : 'Not Modified'}
                        </td>
                        <td className={classes.inputTd}>
                          {item.modificationRemark}
                        </td>
                        <td className={classes.inputTd}>
                          {item.completedAt
                            ? moment(item.completedAt).format('DD MMM YYYY')
                            : null}
                        </td>
                        <td className={classes.inputTd}>{item.remark}</td>
                        <td className={classes.inputTd}>
                          {item.completedAt === null &&
                          item.assigneeId === auth?.user?.id ? (
                            <div style={{ textAlign: 'center', width: '100%' }}>
                              <Button
                                style={classes.button}
                                onClick={() =>
                                  SetActivity({
                                    task: item.fabric
                                      ? `${item.fabric} ${item.width}`
                                      : item.accessory,
                                    subActivityId: item.id,
                                    activityId: item.timeActionActivityId,
                                  })
                                }
                                type="primary"
                              >
                                Complete
                              </Button>
                            </div>
                          ) : null}
                          {item.completedAt &&
                          new Date(item.completedAt) >
                            new Date(item.modPlannedAt || item.plannedAt)
                            ? `${moment(item.completedAt)
                                .endOf('day')
                                .diff(
                                  item.modPlannedAt || item.plannedAt,
                                  'day'
                                )} days delayed`
                            : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Modal>
        ) : null}
        {Activity && Activity.activityId ? (
          <Modal
            visible
            centered
            maskClosable={false}
            closable={false}
            onOk={() => {
              SetActivity(null);
              setValue('remark', null);
            }}
            okText="Close"
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ loading: IsLoading }}
            title={Activity.task}
          >
            <Row>
              <Col xs={24}>
                <Controller
                  name="remark"
                  control={control}
                  render={({ field }) => (
                    <AntInputTextArea
                      allowClear
                      placeholder="Remark"
                      rows={1}
                      {...field}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row className={classes.buttonContainer}>
              <Button type="primary" onClick={onSubmit} loading={IsLoading}>
                Complete
              </Button>
            </Row>
          </Modal>
        ) : null}
      </form>
    </>
  );
};

ViewTimeAction.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(ViewTimeAction);
